export default __webpack_public_path__ + "static/travel-booking-system-a99827f9b7e92a856ec833c8a14acd77.png";